import {
  FetchCreditCardsThunk,
  RemoveCreditCardThunk,
  setSaveCreditCardAction,
  setSelectedCreditCardAction,
} from './creditCardsActions';
import { CreditCardsState } from './creditCardsTypes';
import { useAppAction, useAppSelector } from '../hooks';
import { CREDIT_CARDS_NAMESPACE } from './creditCardsReducer';

export function useCreditCardsSelector<
  T extends (state: CreditCardsState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) => selector(state[CREDIT_CARDS_NAMESPACE]));
}

export const useCreditCards = () =>
  useCreditCardsSelector((state) => {
    return state.creditCards;
  });

export const useSelectedCreditCard = () =>
  useCreditCardsSelector((state) => {
    return state.selectedCreditCard;
  });

export const useSetSaveCreditCard = () => useAppAction(setSaveCreditCardAction);
export const useFetchCreditCards = () => useAppAction(FetchCreditCardsThunk);
export const useRemoveCreditCard = () => useAppAction(RemoveCreditCardThunk);
export const useSetSelectedCreditCard = () =>
  useAppAction(setSelectedCreditCardAction);
